import { AvatarDropzone, Form, Grid, Select, Text, useExtensions } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { memo } from 'react';

import { maxDocumentSize } from './SelfieStep.constants';
import { useDocumentTypes } from './SelfieStep.hooks';
import { messages } from './SelfieStep.messages';

export const SelfieStep = memo(() => {
    const [companyName] = hooks.useQueryParam('companyName');
    const { documentTypes } = useDocumentTypes();
    const extensions = useExtensions(['png', 'jpg', 'pdf']);

    return (
        <Form.Part>
            <Grid gap={16}>
                <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                    {messages.title}
                </Text>

                <Text font='body' fontSize='medium' fontWeight='regular'>
                    {messages.reason({ companyName })}
                </Text>

                <Select
                    disabled
                    name='person.personDocuments.documentType'
                    label={messages.docType}
                    items={documentTypes}
                />

                <AvatarDropzone
                    required
                    rounded={false}
                    name='person.personDocuments.face'
                    label={messages.selfie}
                    hint={messages.requirements}
                    accept={extensions}
                    maxSize={maxDocumentSize}
                />
            </Grid>
        </Form.Part>
    );
});

SelfieStep.displayName = 'SelfieStep';
